import httpClient from "./httpClient";

export async function listarPreFiltros({ somenteAtivos = false } = {}) {
  const response = await httpClient.get("/api/configuracoes/pre-filtros", {
    params: { somenteAtivos },
  });
  return Array.isArray(response.data) ? response.data : [];
}

export async function salvarPreFiltro(preFiltro) {
  const response = await httpClient.post("/api/configuracoes/pre-filtros", preFiltro);
  return response.data || {};
}

export async function removerPreFiltro(id) {
  await httpClient.delete(`/api/configuracoes/pre-filtros/${id}`);
}

// Devolve os vetores prontos (bancosIds, conveniosIds, tiposConvenio) com o "restante" ja calculado
// contra a lista viva de bancos da Join. `incompativel` vem true quando a combinacao escolhida nao
// cabe numa consulta so -- a tela avisa em vez de mostrar numero errado.
export async function resolverPreFiltros(ids = []) {
  if (!ids.length) return { bancosIds: [], conveniosIds: [], tiposConvenio: [], incompativel: false };
  const response = await httpClient.get("/api/configuracoes/pre-filtros/vetores", {
    params: { ids: ids.join(",") },
  });
  return response.data || { bancosIds: [], conveniosIds: [], tiposConvenio: [], incompativel: false };
}
